import React from "react";
import FormationBuilderPage from "../FormationBuilderPage";

const LiaisonSol = () => {
  const liaisonSolProgram = [
    {
      title: "Découverte du monde de l'automobile (Produit/process)",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title: "Architecture Véhicule Thermique / Electrique /Hybride",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title: "Architecture d'ouvrants Modulaire",
      img: "/assets/images/icon/tuyaux.svg",
    },
    {
      title: "Animation de réunion",
      img: "/assets/images/icon/work.svg",
    },
    {
      title: "Prise de parole",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title: "Rédaction de synthèse",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "Management de projet",
      img: "/assets/images/icon/work-women.svg",
    },
    {
      title: "Planning Constructeurs & Equipementiers (V3P +PIV)",
      img: "/assets/images/icon/redaction.svg",
    },
    {
      title: "Logiciels de planification et de gestion  JIRA",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title: "Logiciels de planification et de gestionMS PROJECT",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "Technologies des mécanismes d'ouvrants(Serrure, Câble, COE, COI)",
      img: "/assets/images/icon/balance.svg",
    },
    {
      title: "Etanchéité et vitrage",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "Emboutissage (Acier / Alu)",
      img: "/assets/images/icon/network-card.svg",
    },
    {
      title: "Injection plastique / Rhéologie",
      img: "/assets/images/icon/component-card.svg",
    },
    {
      title:
        "Géometrie Cotation / Iso statisme /Dispersion / Réglage (MAP) Chaine de cote Qualité Percue",
      img: "/assets/images/icon/component-card.svg",
    },
    {
      title: "Acoustique",
      img: "/assets/images/icon/balance.svg",
    },
    {
      title: "Réglementation Auto (charnière , serrure, crash...)",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "Choc latéral, pièton, arrière",
      img: "/assets/images/icon/network-card.svg",
    },
    {
      title: "Eclairage intérieur et Performance Auto",
      img: "/assets/images/icon/component-card.svg",
    },
    {
      title: "Eclairage extérieur (répétiteur)",
      img: "/assets/images/icon/component-card.svg",
    },
    {
      title: "Rétrovision",
      img: "/assets/images/icon/redaction.svg",
    },
    {
      title:
        "Electrique / Electronique Câblage MAP Elec (Ex : porte sans cadre)",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title: "Design (tous les types d'ouvrant)",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "Excel TCD",
      img: "/assets/images/icon/balance.svg",
    },
    {
      title: "Power Point (animation)",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "Construction d'un plan de validation",
      img: "/assets/images/icon/network-card.svg",
    },
    {
      title: "Construction d'un plan d'homologation",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title: "Dimensionnement de l'ensemble Ouvrant",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "PLM",
      img: "/assets/images/icon/balance.svg",
    },
    {
      title: "CATIA V5",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "3D expérience",
      img: "/assets/images/icon/network-card.svg",
    },
    {
      title: "Immersion projet",
      img: "/assets/images/icon/component-card.svg",
    },
  ];

  return (
    <FormationBuilderPage
      category="Automobile"
      titleColor="#2424FF"
      title="Liaison au sol"
      duration={11}
      description={
        <React.Fragment>
          <p>
            Grâce au partenariat entre Liora et SEGULA Technologies, rejoignez
            un groupe d’ingénierie mondiale à forte croissance en tant que
            Liaison au sol, après une formation accélérée de 11 semaines.
          </p>
          <p>
            Impression 3D, réalité augmentée, véhicule autonome, usine du
            futur... rythment le quotidien de nos 13 000 ingénieux
            collaborateurs, pourquoi pas le vôtre ?
          </p>
        </React.Fragment>
      }
      image="/assets/images/home/automobile.png"
      program={liaisonSolProgram}
      formId="2589b2c6-f76c-4ffc-b585-2266b7f6f831"
    />
  );
};

export default LiaisonSol;
